import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import $ from "jquery";
import JsPDF from "jspdf";
import "jspdf-autotable";
import Papa from "papaparse";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { usePermissionGuardRedirect } from "../../../../hooks/usePermissionGuard";
import SkeletonTicketList from "../../../../loaders/SkeletonTicketList";
import {
  DeleteaQuestion,
  DownloadQuestionImportTemplate,
  GetListOfQuestions,
  GetListOfQuestionsCancelToken,
  ImportQuestions,
  ListQuestionFiltersCancelToken,
  QuestionDetailsCancelToken
} from "../../../../services/SmartAssessmentService";
import { handleTableScroll } from "../../../../utils/commonFunction";
import { RenderQuestionLevel, RenderQuestionType } from "../../../../utils/CommonGroupingItem";
import { RenderDate, RenderQuizTopic } from "../../../../utils/CommonStatusItems";
import { TABLE_DATE_FORMAT, TABLE_ROWS_PER_PAGE } from "../../../../utils/Constants";
import { formatQuestion } from "../../../../utils/FormatQuestion";
import { showImportFailurePopup, showImportSuccessPopup } from "../../../../utils/importErrorUtil";
import PermissionsGate from "../../../../utils/permissionGate";
import Str from "../../../common/Str";
import Tablefilter from "../../../common/Tablefilter";
import { TrimText } from "../../../common/TrimText";
import { QuizStatusRender } from "../../../systemadministration/usermanagement/CheckRole";
import DisplayQuestion from "../DisplayQuestion";

var striptags = require("striptags");

const QuestionBank = () => {
  const [search, setSearch] = useState("");
  const [type, setType] = useState({ arr: [], checkObj: {} });
  const [level, setLevel] = useState({ arr: [], checkObj: {} });
  const [qdata, setQData] = useState();
  const [loading, setLoading] = useState(false);
  const [dummy, setDummy] = useState(true);
  const [questionLoading, setQuestionLoading] = useState(false);
  const [questionData, setquestionData] = useState({});

  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [sortkey, setSortKey] = useState("last_modified_date");
  const [sortOrder, setSortOrder] = useState("DESC");
  const [page, setPage] = useState(1);
  const [debouncedTerm, setDebouncedTerm] = useState(search);
  const [topics, setTopics] = useState({ arr: [], checkObj: {} });
  const [filterData, setFilterData] = useState({
    type: [],
    level: [],
    topics: [],
    getMonthlfDate: [],
    getYearlfDate: [],
  });
  const [getMonthlfDate, setgetMonthlfDate] = useState({ arr: [], checkObj: {} });
  const [getYearlfDate, setgetYearlfDate] = useState({ arr: [], checkObj: {} });
  const [cancelToken, setCancelToken] = useState("");
  const [importFile, setImportFile] = useState(null);
  const [importLoading, setImportLoading] = useState(false);

  useEffect(() => {
    handleTableScroll();
  }, [loading]);

  useEffect(() => {
    $(document).ready(function () {
      $(".dropdown-toggle").click(function () {
        $(".rdt_TableCell").css("z-index", 0);
        $(this).parents(".rdt_TableCell").css("z-index", 22);
      });
    });
  }, []);

  usePermissionGuardRedirect(['cquestionbview']);

  useEffect(() => {
    const timer = setTimeout(() => setSearch(debouncedTerm), 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [debouncedTerm]);

  useEffect(() => {
    const storedFilters = JSON.parse(localStorage.getItem("filterStateQBank"));
    if (storedFilters) {
      setType(storedFilters.type);
      setLevel(storedFilters.level);
      setTopics(storedFilters.topics);
      setgetMonthlfDate(storedFilters.getMonthlfDate);
      setgetYearlfDate(storedFilters.getYearlfDate);
    }
  }, []);

  useEffect(() => {
    const filterState = {
      type,
      level,
      topics,
      getMonthlfDate,
      getYearlfDate,
    };
    localStorage.setItem("filterStateQBank", JSON.stringify(filterState));
  }, [type, level, topics, getMonthlfDate, getYearlfDate]);

  const handleSort = (column, sortDirection) => {
    setSortKey(column.sortField);
    setSortOrder(sortDirection === "asc" ? "ASC" : "DESC");
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
  };

  const handlePageChange = (pageNo) => {
    setPage(pageNo);
  };

  useEffect(() => {
    const cancelTokenSources = [];

    const getListOfQuestions = async () => {
      setLoading(true);

      cancelTokenSources.forEach((source) => {
        source.cancel("New request made");
      });

      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);

      const data = {
        page: page,
        limit: perPage,
        search: search,
        key: sortkey,
        sort: sortOrder,
        exportStatus: false,
        viaLevel: level.arr.length > 0 ? level.arr : [],
        viaType: type.arr.length > 0 ? type.arr : [],
        viaTopics: topics.arr.length > 0 ? topics.arr : [],
      };

      try {
        const res = await GetListOfQuestionsCancelToken(data, source.token);
        setQData(res.data?.data);
        setTotalRows(res.data?.total);
        if (res.status == 200) {
          setLoading(false);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          setLoading(false);
        }
      }
    };
    getListOfQuestions();

    return () => {
      cancelTokenSources.forEach((source) => {
        source.cancel("Component unmounted");
      });
    };
  }, [dummy, page, perPage, search, type, level, sortkey, sortOrder, topics]);

  useEffect(() => {
    const dropdownSource = axios.CancelToken.source();

    const fetchData = async () => {
      try {
        const res = await ListQuestionFiltersCancelToken(dropdownSource.token);
        setFilterData({
          ...res.data,
          type: res.data.questionTypeFilters,
          level: res.data.questionLevelFilter,
          topics: res.data.topicFilters,
          getMonthlfDate: res.data.month,
          getYearlfDate: res.data.year,
        });
      } catch (error) {
        if (!axios.isCancel(error)) {
        }
      }
    };

    fetchData();

    return () => {
      dropdownSource.cancel("Component unmounted");
    };
  }, []);

  const handleViewQuestionDetails = (ID) => {
    setQuestionLoading(true);
    setquestionData({});
    const source = axios.CancelToken.source();
    setCancelToken(source);
    QuestionDetailsCancelToken(ID, source.token)
      .then((res) => {
        setquestionData(res.data[0]);
        setQuestionLoading(false);
      })
      .catch((errors) => {
        setQuestionLoading(false);
      });
  };

  const wordSpliter = (str) => {
    if (!str || typeof str !== "string") return "-";

    const trimmed = str.trim();
    if (!trimmed.startsWith("[") || !trimmed.endsWith("]")) return "-";

    let parsed = [];
    try {
      const parsedJson = JSON.parse(trimmed);
      parsed = Array.isArray(parsedJson) ? parsedJson : [];
    } catch (e) {
      parsed = [];
    }

    const newStrArr = parsed.length
      ? parsed.map((item, index) => {
          return item ? (
            <p
              key={index}
              className="as-widget mr-1 mt-1"
              style={{ color: "#333333", background: "#e6e6e6" }}
            >
              {item}
            </p>
          ) : (
            <React.Fragment key={index}>-</React.Fragment>
          );
        })
      : "-";
    return newStrArr;
  };

  const wordSpliterTopics = (str) => {
    let htmlOutput = [];
    const strArr = Array.isArray(str.split(",")) ? str.split(",") : [];

    const newStrArr = strArr.length
      ? strArr.map((item) => {
          filterData.topics.map((val) => {
            if (val.value == item) {
              htmlOutput.push(RenderQuizTopic(val.label, val.color).html);
            }
            return;
          });
        })
      : "-";
    return htmlOutput.length ? htmlOutput : [];
  };

  const wordSpliterTopicsExport = (str) => {
    let htmlOutput = [];
    const strArr = str && Array.isArray(str.split(",")) ? str.split(",") : [];
    const newStrArr = strArr.length
      ? strArr.map((item) => {
          filterData.topics.map((val) => {
            if (val.value == item) {
              htmlOutput.push(RenderQuizTopic(val.label, val.color).text);
            }
            return;
          });
        })
      : "-";
    return htmlOutput.length ? htmlOutput.join(",") : [];
  };

  // Function to extract months and return as objects with value and label
  function extractMonths(dateArray) {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const monthsArray = [];
    dateArray.forEach((monthObj) => {
      const month = monthObj.value;
      const monthName = monthNames[month - 1];
      monthsArray.push({
        value: month,
        label: monthName,
      });
    });

    return monthsArray;
  }

  const columns = useMemo(
    () => [
      {
        name: "Name",
        selector: "question_name",
        sortField: "question_name",
        sortable: true,
        cell: (row, index) => {
          return (
            <Link
              className="as-text-blue curser"
              title={row.question_name ? striptags(row.question_name) : "-"}
              to={
                "/courseAdministration/smartAssessment/questionBank/question/view/" +
                row.qid
              }
            >
              <p className="textLimit150">
                {" "}
                {row.question_name ? formatQuestion(row.question_name) : "-"}{" "}
              </p>
            </Link>
          );
        },
      },

      {
        name: "Type",
        selector: "question_type",
        sortField: "question_type",
        sortable: true,
        cell: (row, index) => (
          <>{row.question_type ? RenderQuestionType(row.question_type.trim()).html : "-"}</>
        ),
      },
      {
        name: "Status",
        selector: "status",
        sortField: "status",
        sortable: true,
        cell: (row, index) => <>{row.status ? QuizStatusRender(row) : "-"}</>,
      },
      {
        name: "Level",
        selector: "level_name",
        sortField: "level_name",
        sortable: true,
        cell: (row, index) =>
          row.level_name ? RenderQuestionLevel(row.level_name).html : "-",
      },
      {
        name: "NQF Level",
        selector: "nqf_level",
        sortField: "nqf_level",
        sortable: true,
        cell: (row, index) =>
          row.nqf_level ? <span>NQF {row.nqf_level.replace("NQF ", "")}</span> : "-",
      },
      {
        name: "#Linked Quizzes",
        selector: "AssigendToassessmentCount",
        sortField: "AssigendToassessmentCount",
        sortable: true,
        cell: (row, index) => (
          <p>
            {row.AssigendToassessmentCount.toString()
              ? row.AssigendToassessmentCount
              : "-"}
          </p>
        ),
      },
      {
        name: "Keywords",
        cell: (row) =>
          row?.keywords ? <div className="d-flex flex-wrap">{wordSpliter(row.keywords)}</div> : "-",
      },
      {
        name: "Topics",
        cell: (row) =>
          row?.topic ? (
            <div className="d-flex flex-wrap">
              {wordSpliterTopics(row.topic).length
                ? wordSpliterTopics(row.topic).map((item, index) => (
                    <React.Fragment key={index}>{item} &nbsp;</React.Fragment>
                  ))
                : ""}
            </div>
          ) : (
            "-"
          ),
      },
      {
        name: "Last Modified Date",
        selector: "last_modified_date",
        sortField: "last_modified_date",
        sortable: true,
        cell: (row) => {
          const moment = require("moment");
          if (row.last_modified_date) {
            const formattedDate =
              moment(row.last_modified_date).format(TABLE_DATE_FORMAT).toString() ===
              "Invalid date"
                ? "-"
                : moment(row.last_modified_date).format(TABLE_DATE_FORMAT);

            return formattedDate;
          } else {
            return "-";
          }
        },
      },
      {
        name: "Actions",
        maxWidth: "50px",
        cell: (row, index) => (
          <div className="assessment-08 btn-dropdown-grp">
            <div className="as-buttons d-flex">
              <Link
                className="btn btn-primary rounded-circle"
                title="Open"
                to={
                  "/courseAdministration/smartAssessment/questionBank/question/view/" +
                  row?.qid
                }
              >
                <i className="fal fa-folder-open"></i>
              </Link>
              <div className="dropdown btn-dropdown-item ml-1">
                <button
                  className="btn btn-primary rounded-circle dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  title="More"
                >
                  <i className="fal fa-ellipsis-h-alt"></i>
                </button>
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <PermissionsGate
                    scopes={["cquestionbadd"]}
                    RenderError={() => (
                      <button
                        className="btn btn-primary rounded-circle ml-1"
                        title="Duplicate"
                        disabled
                      >
                        <i className="fal fa-copy"></i>
                      </button>
                    )}
                  >
                    {row?.question_type === "Long Answer" ? (
                      <button
                        className="btn btn-primary rounded-circle ml-1"
                        title="Duplicate"
                        disabled
                      >
                        <i className="fal fa-copy"></i>
                      </button>
                    ) : (
                      <Link
                        className="btn btn-primary rounded-circle ml-1"
                        title="Duplicate"
                        to={
                          "/courseAdministration/smartAssessment/questionBank/question/duplicate/" +
                          row?.qid
                        }
                      >
                        <i className="fal fa-copy"></i>
                      </Link>
                    )}
                  </PermissionsGate>
                  <button
                    className="btn btn-primary rounded-circle"
                    data-toggle="modal"
                    data-target="#question"
                    title="View Question"
                    onClick={() => {
                      handleViewQuestionDetails(row.qid);
                    }}
                  >
                    <i className="fal fa-eye"></i>
                  </button>
                  <PermissionsGate scopes={["cquestionbdelete"]} errorProps={{ disabled: true }}>
                    <button
                      className="btn btn-danger rounded-circle"
                      title="Delete"
                      onClick={() => handleDelete(row.qid)}
                    >
                      <i className="fal fa-trash-alt"></i>
                    </button>
                  </PermissionsGate>
                </div>
              </div>
            </div>
          </div>
        ),
      },
    ],
    []
  );

  const handleDelete = (ID) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        DeleteaQuestion({ questionId: ID })
          .then((res) => {
            Swal.fire("Deleted!", "Your question has been deleted.", "success");
            setDummy(!dummy);
          })
          .catch(() => {
            Swal.fire("Error", "Failed to delete question. Please try again.", "error");
          });
      }
    });
  };

  function resetFilter() {
    setSearch("");
    setType({ arr: [], checkObj: {} });
    setLevel({ arr: [], checkObj: {} });
    setDebouncedTerm("");
    setTopics({ arr: [], checkObj: {} });
    setgetMonthlfDate({ arr: [], checkObj: {} });
    setgetYearlfDate({ arr: [], checkObj: {} });
  }

  const handleDownloadTemplate = async () => {
    try {
      const res = await DownloadQuestionImportTemplate();
      const blob = new Blob([res.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "Smart Assessment Template.csv";
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      Swal.fire("Error", "Failed to download template.", "error");
    }
  };

  const handleImportQuestions = async () => {
    if (!importFile) return;

    try {
      setImportLoading(true);

      const formData = new FormData();
      formData.append("file", importFile);

      const res = await ImportQuestions(formData);

      if (res?.data?.errors?.length) {
        showImportFailurePopup(res.data);
        return;
      }

      const total = res.data?.total ?? 0;
      const imported = res.data?.imported ?? 0;

      showImportSuccessPopup({ total, imported });

      setImportFile(null);
      $("#importQuestionsModal").modal("hide");
      setDummy((prev) => !prev);
    } catch (error) {
      const payload = error?.response?.data;

      if (payload?.errors?.length) {
        showImportFailurePopup(payload);
        return;
      }

      Swal.fire({
        icon: "error",
        title: "Import Failed",
        text: payload?.message || error.message || "Server error during import.",
        width: "400px",
      });
    } finally {
      setImportLoading(false);
    }
  };

  const exportData = async (fileType, fileName) => {
    let data;

    const header = [
      "Name",
      "Type",
      "Status",
      "Level",
      "NQF Level",
      "#Linked Quizzes",
      "Last Modified Date",
      "Keywords",
      "Topics",
    ];

    Swal.fire({
      title: "File downloading",
      onOpen: function () {
        Swal.showLoading();
      },
    });

    GetListOfQuestions({
      page: page,
      limit: perPage,
      search: search,
      key: sortkey,
      sort: sortOrder,
      exportStatus: true,
      viaLevel: level.arr.length > 0 ? level.arr : [],
      viaType: type.arr.length > 0 ? type.arr : [],
      viaTopics: topics.arr.length > 0 ? topics.arr : [],
    }).then((res) => {
      data = res?.data;
      data = data?.map((row) => ({
        ...row,
        Name: row.question_name ? TrimText(row.question_name, 20) : "-",
        Type: row.question_type ? RenderQuestionType(row.question_type).text : "-",
        Status: row.status ? row.status : "-",
        Level: row.level_name ? RenderQuestionLevel(row.level_name).text : "-",
        "NQF Level": row.nqf_level ? `NQF ${row.nqf_level.replace("NQF ", "")}` : "-",
        "#Linked Quizzes": row.AssigendToassessmentCount?.toString()
          ? row.AssigendToassessmentCount
          : "-",
        "Last Modified Date": row.last_modified_date ? row.last_modified_date : "-",
        Keywords: (() => {
          const raw = row?.keywords;

          if (!raw || typeof raw !== "string") return "-";

          const trimmed = raw.trim();
          if (!trimmed.startsWith("[") || !trimmed.endsWith("]")) return "-";

          try {
            const parsed = JSON.parse(trimmed);
            if (!Array.isArray(parsed) || parsed.length === 0) return "-";
            return parsed.join(", ");
          } catch (e) {
            return "-";
          }
        })(),
        Topics: row.topic && wordSpliterTopicsExport(row.topic).length ? wordSpliterTopicsExport(row.topic) : "-",
      }));

      if (fileType === "csv") {
        const csvString = Papa.unparse({ fields: header, data });
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });

        const blobURL = window.URL.createObjectURL(blob);

        const anchor = document.createElement("a");
        anchor.download = fileName;
        anchor.href = blobURL;
        anchor.dataset.downloadurl = ["text/csv", anchor.download, anchor.href].join(":");
        anchor.click();

        setTimeout(() => {
          URL.revokeObjectURL(blobURL);
        }, 1000);
        Swal.close();
      } else if (fileType === "xlsx") {
        const compatibleData = data.map((row) => {
          const obj = {};
          header.forEach((col, index) => {
            obj[col] = row[col];
          });
          return obj;
        });

        let wb = XLSX.utils.book_new();
        let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
          header,
        });
        XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
        XLSX.writeFile(wb, `${fileName}.xlsx`);
        Swal.close();
        return false;
      }

      if (fileType === "pdf") {
        const compatibleData = data.map((row) => {
          return [
            row["Name"],
            row["Type"],
            row["Status"],
            row["Level"],
            row["NQF Level"],
            row["#Linked Quizzes"],
            row["Last Modified Date"],
            row["Keywords"],
            row["Topics"],
          ];
        });
        const doc = new JsPDF();
        doc.autoTable({
          head: [header],
          body: compatibleData,
          styles: {
            minCellHeight: 10,
            minCellWidth: 5,
            halign: "left",
            fontSize: 8,
          },
          columnStyles: {
            0: { columnWidth: 30 },
            1: { columnWidth: 30 },
            2: { columnWidth: 20 },
            3: { columnWidth: 20 },
            4: { columnWidth: 20 },
            5: { columnWidth: 20 },
            6: { columnWidth: 20 },
            7: { columnWidth: 20 },
            8: { columnWidth: 20 },
          },
        });
        doc.save(`${fileName}.pdf`);
        Swal.close();
        return false;
      }
    });
  };

  function stopAudioAndVideo(event) {
    let modal = document.getElementById("question");
    let element = modal.getElementsByClassName("form-group");
    let elementArr = Array.from(element);
    if (elementArr.length) {
      elementArr[0].remove();
    }
  }

  useEffect(() => {
    $("#question").on("hidden.bs.modal", stopAudioAndVideo);
  }, []);

  return (
    <div className="my-tickets-info-list Tickets-main-wrap tickets-new-custom">
      <div className="custom-table-div filter-search-icon card card-table-custom qus-bank-table">
        <div className="search-filter-div">
          <div className="search-filter-div-left">
            <div className="system-administration-table table-responsive">
              <div className="table-responsive-div">
                <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer">
                  <div id="assessment-table-main_filter" className="dataTables_filter">
                    <label>
                      <input
                        type="search"
                        placeholder="Search"
                        aria-controls="assessment-table-main"
                        onChange={(e) => setDebouncedTerm(e.target.value)}
                        value={debouncedTerm}
                      />
                    </label>
                    <div className="filter-eff filter-data-btn">
                      <button className="filter-buttons">
                        <i className="fal fa-filter"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="filter-button-group">
                <div className="filter-scroll">
                  <div className={`filter-scroll-inner  filter-custom-new`}>
                    <Tablefilter
                      filterName="Type"
                      optionArr={filterData.type}
                      state={type}
                      setState={setType}
                      renderLabelFunction={RenderQuestionType}
                    />
                    <Tablefilter
                      filterName="Level"
                      optionArr={filterData.level}
                      state={level}
                      setState={setLevel}
                      renderLabelFunction={RenderQuestionLevel}
                    />
                    <Tablefilter
                      filterName="Topic"
                      optionArr={filterData.topics}
                      state={topics}
                      setState={setTopics}
                      renderLabelFunction={RenderQuizTopic}
                      uniqueId="topic"
                    />
                    <Tablefilter
                      filterName="Month"
                      optionArr={extractMonths(filterData.getMonthlfDate || [])}
                      state={getMonthlfDate}
                      setState={setgetMonthlfDate}
                    />
                    <Tablefilter
                      filterName="Year"
                      optionArr={filterData.getYearlfDate || []}
                      state={getYearlfDate}
                      setState={setgetYearlfDate}
                      renderLabelFunction={RenderDate}
                      uniqueId="Date"
                    />
                  </div>
                </div>

                <div className="reset-btn-group">
                  <div className="button-reset dropdown-comman">
                    <button className="btn btn-primary" onClick={resetFilter} title="Reset">
                      <i className="fal fa-redo"></i>Reset
                    </button>
                  </div>

                  <div className="files-export-group">
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("xlsx", "Questions");
                      }}
                      title="Export spreadsheet"
                    >
                      <i className="fal fa-file-excel"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("csv", "Questions");
                      }}
                      title="Export CSV"
                    >
                      <i className="fal fa-file-csv"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("pdf", "Questions");
                      }}
                      title="Export PDF"
                    >
                      <i className="fal fa-file-pdf"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="search-filter-div-right">
            <div className="filter-search-bar-blk">
              <div className="add-ticket-blk button-reset dropdown-comman d-flex align-items-center">
                <PermissionsGate scopes={["cquestionbimportadd"]} errorProps={{ disabled: true }}>
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-toggle="modal"
                    data-target="#importQuestionsModal"
                    title="Import Questions"
                  >
                    <i className="fal fa-file-import"></i>Import
                  </button>
                </PermissionsGate>
                <PermissionsGate
                  scopes={["cquestionbadd"]}
                  RenderError={() => (
                    <button type="button" className="btn btn-primary ml-2" title="Create New" disabled>
                      <i className="fal fa-plus"></i>Create New
                    </button>
                  )}
                >
                  <Link
                    className="btn btn-primary ml-2"
                    to="/courseAdministration/smartAssessment/addquestion"
                  >
                    <i className="fal fa-plus"></i>Create New
                  </Link>
                </PermissionsGate>
              </div>
            </div>
          </div>
        </div>
        <DataTable
          data={qdata}
          defaultSortField="last_modified_date"
          defaultSortAsc={false}
          columns={columns}
          pagination={true}
          noDataComponent={Str.noRecord}
          progressPending={loading}
          progressComponent={<SkeletonTicketList />}
          onSort={handleSort}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          highlightOnHover={false}
          paginationServer
          paginationTotalRows={totalRows}
          paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
        />
      </div>

      <div
        className="topic-add-modal modal fade"
        id="question"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content modal-border-update">
            <div className="modal-body p-0">
              <div className="modal-header modal-header-custom">
                <h5 className="modal-title">View Question</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    cancelToken.cancel("Component unmounted");
                    setCancelToken("");
                    $("#question").modal("hide");
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="t p-30px">
                <DisplayQuestion
                  question={questionData}
                  from="questionBank"
                  component_code={questionData?.component_code}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="topic-add-modal modal fade" id="importQuestionsModal" tabIndex="-1" role="dialog" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-md" role="document">
          <div className="modal-content modal-border-update">
            <div className="modal-body p-0">
              <div className="modal-header modal-header-custom">
                <h5 className="modal-title">Import Questions</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setImportFile(null);
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="p-4">
                <div className="form-group mb-3">
                  <label>Upload CSV file</label>
                  <input
                    type="file"
                    accept=".csv,text/csv"
                    className="form-control"
                    style={{ height: "44px", paddingTop: "6px", paddingBottom: "6px" }}
                    onChange={(e) => {
                      const file = e.target.files?.[0] || null;
                      if (!file) {
                        setImportFile(null);
                        return;
                      }

                      const isCsvExt = file.name.toLowerCase().endsWith(".csv");
                      const maxSizeBytes = 20 * 1024 * 1024; 

                      if (!isCsvExt) {
                        Swal.fire("Wrong file", "Please upload a .csv file.", "warning");
                        e.target.value = "";
                        setImportFile(null);
                        return;
                      }

                      if (file.size > maxSizeBytes) {
                        Swal.fire("File too large", "CSV must be 20MB or less.", "warning");
                        e.target.value = "";
                        setImportFile(null);
                        return;
                      }

                      setImportFile(file);
                    }}
                  />
                </div>

                <div className="d-flex justify-content-between mt-3">
                  <button type="button" className="btn btn-secondary" onClick={handleDownloadTemplate}>
                    <i className="fal fa-download mr-1"></i>Download Template
                  </button>

                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={!importFile || importLoading}
                    onClick={handleImportQuestions}
                  >
                    <i className="fal fa-file-import mr-1"></i>
                    {importLoading ? "Importing..." : "Import"}
                  </button>
                </div>

                {!importFile ? (
                  <small className="text-muted d-block mt-2">Select a CSV file to enable Import.</small>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionBank;